import { useState, useEffect } from "react";
import { useLanguage } from "@/context/LanguageContext";
import useSeo from "@/hooks/useSeo";
import { PageHero } from "@/components/PageHero";
import { toast } from "sonner";

export default function Cookies() {
  const { t } = useLanguage();
  const [accepted, setAccepted] = useState(false);
  useSeo("Cookie-Einstellungen", "Paramètres des cookies", "Cookie-Einstellungen von Our Promise Events.", "Paramètres des cookies d'Our Promise Events.");

  useEffect(() => setAccepted(!!localStorage.getItem("ope_cookie_ok")), []);

  const save = () => {
    localStorage.setItem("ope_cookie_ok", "1");
    setAccepted(true);
    toast.success(t("admin.saved"));
  };

  return (
    <div data-testid="cookies-page">
      <PageHero title={t("legal.cookiesTitle")} />
      <section className="bg-cream py-20 px-6">
        <div className="max-w-2xl mx-auto text-ink/85 leading-relaxed space-y-8">
          <p>{t("cookie.text")}</p>
          <div className="flex items-center justify-between border border-border p-6 bg-card">
            <div>
              <p className="font-heading text-xl">Notwendige Cookies</p>
              <p className="text-sm text-ink-muted">Immer aktiv</p>
            </div>
            <span className="text-xs tracking-widest uppercase text-gold">{accepted ? "Aktiv" : "Aktiv"}</span>
          </div>
          <button onClick={save} data-testid="cookies-save" className="bg-ink text-cream px-9 py-4 text-[11px] tracking-[0.3em] uppercase hover:bg-gold transition-colors duration-500">
            {t("cookie.accept")}
          </button>
        </div>
      </section>
    </div>
  );
}
